import styled, { useTheme } from 'styled-components';
import Modal from '../../../components/Modal';
import Button from '../../../components/Button';
import { useEffect, useState } from 'react';
import {
  BodyLarge,
  ParagraphLargeText,
  ParagraphMediumText,
  TitleMedium,
} from '../../../components/Texts';
import { useSelector } from 'react-redux';
import { selectPrivyToken } from '../../../redux/slices/auth';
import { useGetCurrentUserProfileQuery } from '../../../redux/api/authorized/auth';
import TextInput from '../../../components/Inputs/Text';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../../common/responsive';
import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';
import { selectThemeMode } from '../../../redux/slices/themeSlice';

const Referrals = ({ onClose }) => {
  const privyToken = useSelector(selectPrivyToken);
  const [referralLink, setReferralLink] = useState('');
  const { data: userData } = useGetCurrentUserProfileQuery(undefined, {
    skip: !privyToken,
  });

  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  const theme = useTheme();

  const themeMode = useSelector(selectThemeMode);

  useEffect(() => {
    if (userData) {
      setReferralLink(`https://deks.xyz/?rc=${userData?.referralCode}`);
    }
  }, [userData]);

  return (
    <Modal onClose={onClose}>
      <div style={{ display: 'flex', gap: 15, flexDirection: 'column' }}>
        <div style={{ display: 'flex', gap: 12, flexDirection: 'column' }}>
          <ParagraphLargeText
            style={{
              fontWeight: '600',
              textAlign: 'center',
              color: theme.text.title,
            }}
          >
            Invite Friends
          </ParagraphLargeText>
          <img
            width={'100%'}
            src={
              themeMode === 'light'
                ? '/rewards/referralModal.webp'
                : '/rewards/referralModal-dark.webp'
            }
          />
        </div>
        <div style={{ display: 'flex', gap: 15, flexDirection: 'column' }}>
          <TitleMedium style={{ fontWeight: 600, color: theme.text.title }}>
            Invite friends, earn cashback together
          </TitleMedium>
          <BodyLarge>
            Earn 1% casback in Solana and SKR when you or your invited friends spend at real-world shops.
          </BodyLarge>
        </div>
        {Capacitor.isNativePlatform() &&
        Capacitor.isPluginAvailable('Share') ? (
          <Button
            fullWidth={isMobile}
            onClick={() => {
              Share.share({
                url: referralLink,
              });
            }}
          >
            Share Link
          </Button>
        ) : (
          <>
            <TextInput
              copy
              label='Referral link'
              value={`https://deks.xyz/?rc=${userData?.referralCode}`}
              disabled
            ></TextInput>
            <div
              style={{
                display: 'flex',
                gap: 8,
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <ParagraphMediumText
                style={{
                  fontWeight: 600,
                  color: `${theme.text.secondary}`,
                }}
              >
                Or
              </ParagraphMediumText>
              <div style={{ display: 'flex', gap: 16 }}>
                <img
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    const text = encodeURIComponent(
                      `Join Deks and start gifting: ${referralLink}`,
                    );
                    window.open(`https://wa.me/?text=${text}`, '_blank');
                  }}
                  src='/rewards/whatsapp.webp'
                  width={isMobile ? 36 : 48}
                  height={isMobile ? 36 : 48}
                />
                <img
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    const text = encodeURIComponent(
                      `Join Deks and start gifting: ${referralLink}`,
                    );
                    window.open(
                      `https://t.me/share/url?url=${referralLink}&text=${text}`,
                      '_blank',
                    );
                  }}
                  src='/rewards/telegram.webp'
                  width={isMobile ? 36 : 48}
                  height={isMobile ? 36 : 48}
                />
                <img
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    const body = encodeURIComponent(
                      `Join Deks and start gifting: ${referralLink}`,
                    );
                    window.open(`sms:?body=${body}`, '_blank');
                  }}
                  src='/rewards/sms.webp'
                  width={isMobile ? 36 : 48}
                  height={isMobile ? 36 : 48}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default Referrals;
